import { render, staticRenderFns } from "./SummaryChartTab.vue?vue&type=template&id=295b835e"
import script from "./SummaryChartTab.vue?vue&type=script&lang=js"
export * from "./SummaryChartTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports